import WhatsAppIcon from "./WhatsAppIcon";
import { waLink } from "../config";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Connect on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1FAF54] text-white shadow-[0_10px_32px_rgba(31,175,84,0.45)] transition-transform duration-300 hover:scale-105"
    >
      <span aria-hidden="true" className="wa-ring absolute inset-0 rounded-full bg-[#1FAF54]" />
      <WhatsAppIcon className="relative h-7 w-7" />
    </a>
  );
}
